import { WelcomeDialogs } from "generated/CoreApi_v1";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router";
import { AssPlayerEvaluation } from "views/assessment/player/AssPlayerEvaluation";
import { AssPlayerSurvey } from "views/assessment/player/AssPlayerSurvey";
import { DirectMessageDialog } from "views/foundation/directMessage/DirectMessageDialog";
import { TrainingRegistrationDialog } from "views/lms/student/Registration/TrainingRegistrationDialog";

///////////////////////////////////////////////////////////////////////////////

type DiscoveryDialogParams = {
    params: URLSearchParams;
    readonly?: boolean;
    onClose: () => void;
};

///////////////////////////////////////////////////////////////////////////////

///
function trainingRegistration({ params, readonly, onClose }: DiscoveryDialogParams) {
    const trainingId = params.get("t");
    if (trainingId) {
        return <TrainingRegistrationDialog
            readonly={readonly}
            onClose={onClose}
            trainingId={trainingId}
        />;
    }
    return null;
}



///
function assSurvey({ params, onClose }: DiscoveryDialogParams) {
    const assessmentId = params.get("a");
    const deployId = params.get("d");
    const participantId = params.get("p");
    if (assessmentId && deployId && participantId) {
        return <AssPlayerSurvey
            assessmentId={assessmentId}
            deployId={deployId}
            deployParticipantId={participantId}
            mode="play"
            onClose={onClose}
        />;
    }
    return null;
}

///
function assEvaluation({ params, onClose }: DiscoveryDialogParams) {
    const assessmentId = params.get("a");
    const deployId = params.get("d");
    const participantId = params.get("p");
    const instanceId = null;
    // TODO: fazer chamada na API para capturar a última Instance.

    if (assessmentId && deployId && participantId) {
        return <AssPlayerEvaluation
            deployParticipantId={participantId}
            deployId={deployId}
            assessmentId={assessmentId}
            instanceId={instanceId}
            onClose={onClose}
        />;
    }
    return null;
}

///
function directMessage({ onClose }: DiscoveryDialogParams) {
    return <DirectMessageDialog onClose={onClose} />;
}

///////////////////////////////////////////////////////////////////////////////

export const HomeDialogs: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [dialog, setDialog] = useState<any>(null);

    useEffect(() => {
        const dlg = searchParams.get("dlg");
        if (dlg != null) {

            const p: DiscoveryDialogParams = {
                onClose: () => setDialog(null),
                params: searchParams
            };

            switch (parseInt(dlg)) {
                case WelcomeDialogs.Registration: setDialog(trainingRegistration(p)); break;
                case WelcomeDialogs.Survey: setDialog(assSurvey(p)); break;
                case WelcomeDialogs.Evaluation: setDialog(assEvaluation(p)); break;
                case WelcomeDialogs.DirectMessage: setDialog(directMessage(p)); break;
                case WelcomeDialogs.TrainingInfo: setDialog(trainingRegistration({ ...p, readonly: true })); break;
                default: setDialog(null);
            }

            setSearchParams("");
        }
    }, []);

    return dialog;
};
